module.exports = __webpack_public_path__ + "static/img/RWD.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RWD.png
// module id = Z6iG
// module chunks = 0